



















































































import Vue from "vue";
import {
  required,
  integer,
  minValue,
  minLength,
  requiredIf
} from "vuelidate/lib/validators";
import dialog from "@/common/mixins/dialog";

import PromotionGroupCard from "../components/PromotionGroupCard.vue";
import {
  PromotionCreateForm,
  PromotionItemGroupForm,
  PromotionItemStatus,
  PromotionItemForm,
  PromotionConditionPriceForm
} from "../forms/PromotionCreateForm";
import { Shop } from "../../shop/models/Shop";
import { Channel } from "../../channel/models/Channel";
import { Item } from "../../item/models/Item";

export default Vue.extend({
  mixins: [dialog],
  components: {
    PromotionGroupCard
  },
  validations: {
    promotionCreateForm: {
      name: { required },
      shop: { required },
      startDate: { required },
      promotionGroup: {
        channelsSelected: {
          required,
          minLength: minLength(1)
        },
        conditionItemGroups: {
          $each: {
            items: {
              required: requiredIf(function(this: any) {
                return this.isConditionTypeProduct;
              }),
              minLength: minLength(1),
              $each: {
                status: {
                  sameAs: function(status: any) {
                    return status === PromotionItemStatus.Success;
                  }
                }
              }
            }
          }
        },
        promotionItemGroups: {
          $each: {
            items: {
              required: requiredIf(function(this: any) {
                return this.isConditionTypeProduct;
              }),
              minLength: minLength(1),
              $each: {
                status: {
                  sameAs: function(status) {
                    return status === PromotionItemStatus.Success;
                  }
                }
              }
            }
          }
        },
        promotionConditionPrices: {
          $each: {
            price: { required, minValue: minValue(0) },
            promotionItemGroups: {
              $each: {
                items: {
                  required: requiredIf(function(this: any) {
                    return this.isConditionTypePrice;
                  }),
                  minLength: minLength(1),
                  $each: {
                    status: {
                      sameAs: function(status: any) {
                        return status === PromotionItemStatus.Success;
                      }
                    }
                  }
                }
              }
            }
          }
        },
        orderLimit: {
          required,
          integer,
          minValue: minValue(0)
        },
        orderItemLimitAmount: {
          required: requiredIf(function(this: any) {
            return this.promotionCreateForm.promotionGroup.orderItemLimit;
          }),
          integer,
          minValue: minValue(1)
        }
      }
    }
  },
  data() {
    const shops: Shop[] = [];
    const channels: Channel[] = [];
    const isLoading = false;
    const isShowDialog = false;
    const errorMessages = "";
    const promotionCreateForm: PromotionCreateForm = {
      name: "",
      promotionGroup: {
        channelsSelected: [],
        conditionType: "PRODUCT",
        conditionItemGroups: [{ items: [] }],
        promotionItemGroups: [{ items: [] }],
        promotionConditionPrices: [
          { price: 0, promotionItemGroups: [{ items: [] }] }
        ],
        orderLimit: 0,
        orderItemLimit: false,
        orderItemLimitAmount: null,
        promotionHold: false
      },
      inuse: true
    };

    return {
      shops,
      channels,
      isLoading,
      isShowDialog,
      errorMessages,
      promotionCreateForm
    };
  },
  computed: {
    shopOptions() {
      return (this as any).shops;
    },
    channelOptions() {
      return (this as any).channels;
    },
    isConditionTypeProduct() {
      return (
        (this as any).promotionCreateForm.promotionGroup.conditionType ===
        "PRODUCT"
      );
    },
    isConditionTypePrice() {
      return (
        (this as any).promotionCreateForm.promotionGroup.conditionType ===
        "PRICE"
      );
    },
    nameError() {
      return (this as any).$v.promotionCreateForm.name.$error
        ? "ชื่อ Promotion is required"
        : "";
    },
    shopError() {
      return (this as any).$v.promotionCreateForm.shop.$error
        ? "ร้าน is required"
        : "";
    },
    startDateError() {
      return (this as any).$v.promotionCreateForm.startDate.$error
        ? "วันเริ่ม is required or invalid"
        : "";
    }
  },
  async created() {
    await Promise.all([this.getShops(), this.getChannels()]);
  },
  methods: {
    goToPromotionViewPage() {
      this.$router.push({ name: "PromotionViewPage" });
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to create promotion",
        "คุณต้องการเพิ่ม Promotion หรือไม่ ?"
      );
      if (isConfirmed) {
        await this.createPromotion();
      }
    },
    clear() {
      this.$v.$reset();

      this.promotionCreateForm = {
        name: "",
        promotionGroup: {
          channelsSelected: [],
          conditionType: "PRODUCT",
          conditionItemGroups: [{ items: [] }],
          promotionItemGroups: [{ items: [] }],
          promotionConditionPrices: [
            { price: 0, promotionItemGroups: [{ items: [] }] }
          ],
          orderLimit: 0,
          orderItemLimit: false,
          orderItemLimitAmount: null,
          promotionHold: false
        },
        inuse: true
      };
    },
    async getShops() {
      try {
        const { data } = await (this as any).$dep.shopUseCase.getShops({
          perPage: 9999
        });
        this.shops = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async getChannels() {
      try {
        const { data } = await (this as any).$dep.channelUseCase.getChannels({
          perPage: 9999
        });
        this.channels = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async createPromotion() {
      try {
        this.isLoading = true;

        const promotion = await (this as any).$dep.promotionUseCase.createPromotion(
          this.promotionCreateForm
        );
        if (
          await (this as any).alertSuccess("Success", "เพิ่ม Promotion สำเร็จ")
        ) {
          this.goToPromotionViewPage();
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          process.env.NODE_ENV === "production"
            ? (this as any).alertError("Error", "ไม่สามารถสร้าง Promotion ได้")
            : (this as any).alertError("Error", error);
        }
      } finally {
        this.isLoading = false;
      }
    },
    getInitCheckItem(
      itemGroups: PromotionItemGroupForm[]
    ): PromotionItemForm[] {
      const initItems: PromotionItemForm[] = [];

      itemGroups.forEach((itemGroup: PromotionItemGroupForm) => {
        itemGroup.items.forEach((item: PromotionItemForm) => {
          if (item.status === PromotionItemStatus.Init) {
            initItems.push(item);
          }
        });
      });

      return initItems;
    },
    async checkConditionItem() {
      try {
        const initItems = this.getInitCheckItem(
          this.promotionCreateForm.promotionGroup.conditionItemGroups
        );

        const foundItems = await this.getFoundItems(initItems);

        const newCondtionItemGroups = this.promotionCreateForm.promotionGroup.conditionItemGroups.map(
          (e: PromotionItemGroupForm) => {
            const items = this.changeItemsStatus(e, foundItems);
            return { ...e, items };
          }
        );

        this.promotionCreateForm.promotionGroup.conditionItemGroups = newCondtionItemGroups;
      } catch (error) {
        return error;
      }
    },
    async checkPromotionItem() {
      try {
        const initItems = this.getInitCheckItem(
          this.promotionCreateForm.promotionGroup.promotionItemGroups
        );

        const foundItems = await this.getFoundItems(initItems);

        const newPromotionItemGroups = this.promotionCreateForm.promotionGroup.promotionItemGroups.map(
          (e: PromotionItemGroupForm) => {
            const items = this.changeItemsStatus(e, foundItems);
            return { ...e, items };
          }
        );

        this.promotionCreateForm.promotionGroup.promotionItemGroups = newPromotionItemGroups;
      } catch (error) {
        return error;
      }
    },
    async checkConditionPriceItem() {
      try {
        let initItems: PromotionItemForm[] = [];
        this.promotionCreateForm.promotionGroup.promotionConditionPrices.forEach(
          (condition: PromotionConditionPriceForm) => {
            initItems = initItems.concat(
              this.getInitCheckItem(condition.promotionItemGroups)
            );
          }
        );

        const foundItems = await this.getFoundItems(initItems);

        const newPromotionConditionPrices = this.promotionCreateForm.promotionGroup.promotionConditionPrices.map(
          (e: PromotionConditionPriceForm) => {
            const promotionItemGroups = e.promotionItemGroups.map(
              (promotionItemGroup: PromotionItemGroupForm) => {
                const items = this.changeItemsStatus(
                  promotionItemGroup,
                  foundItems
                );
                return { ...promotionItemGroup, items };
              }
            );
            return { ...e, promotionItemGroups };
          }
        );

        this.promotionCreateForm.promotionGroup.promotionConditionPrices = newPromotionConditionPrices;
      } catch (error) {
        return error;
      }
    },
    changeItemsStatus(
      promotionItemGroup: PromotionItemGroupForm,
      foundItems: Item[]
    ) {
      return promotionItemGroup.items.map((item: PromotionItemForm) => {
        if (item.status === PromotionItemStatus.Init) {
          const foundItem = foundItems.find(foundItem => {
            return foundItem.code === item.sku;
          });

          if (foundItem) {
            return {
              ...item,
              name: foundItem.name,
              status: PromotionItemStatus.Success
            };
          } else {
            return {
              ...item,
              status: PromotionItemStatus.Fail
            };
          }
        }
        return item;
      });
    },
    async checkItem(sku: string) {
      try {
        const { data } = await (this as any).$dep.itemUseCase.checkItem(
          this.promotionCreateForm.shop,
          sku
        );
        return data;
      } catch (error) {
        return null;
      }
    },
    async getFoundItems(items: PromotionItemForm[]) {
      return (
        await Promise.all(
          items.map((e: PromotionItemForm) => {
            return this.checkItem(e.sku);
          })
        )
      ).filter(e => e);
    }
  }
});
